<template>
  <v-layout align-center justify-center column fill-height>
    <v-progress-circular :size="150" color="light-green" indeterminate/>
    <div class="headline mt-5">
      Loading...
    </div>
  </v-layout>
</template>

<script>
  export default {
    name: 'LoadingPage'
  }
</script>
